import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, Fragment } from 'react';
import { IconOptions } from 'types';
import './heading-item.scss';

type Props = {
    text: string;
    textColor?: string;
    backgroundColor?: string;
    rightHandIcon?: IconOptions;
    rightHandRender?: () => React.ReactNode;
    leftHandRender?: () => React.ReactNode;
    leftHandIcon?: IconOptions;
    onClick?: () => void;
};

export const HeadingItem: FC<Props> = ({ text, textColor = '#0066A4', backgroundColor = '#F1F1F1', onClick, rightHandRender, leftHandIcon, leftHandRender, rightHandIcon }) => {
    let leftHandSide: React.ReactNode = leftHandRender
        ? leftHandRender() : ((leftHandIcon && Object.keys(leftHandIcon).length > 0)
            ? <FontAwesomeIcon icon={leftHandIcon.icon as IconProp} color={leftHandIcon.color} size={leftHandIcon.size} />
            : <Fragment />)

    let rightHandSide: React.ReactNode = rightHandRender
        ? rightHandRender() : ((rightHandIcon && Object.keys(rightHandIcon).length > 0)
            ? <FontAwesomeIcon icon={rightHandIcon.icon as IconProp} color={rightHandIcon.color} size={rightHandIcon.size} />
            : <Fragment />)

    return (
        <Fragment>
            <div className={'search-result-heading-container'}>
                <div className={'search-result-heading-left'}>
                    {leftHandSide}
                </div>
                <div className={'search-result-heading-center'}>
                    {text ?
                        <div className={`heading-item-container`} style={{ backgroundColor: backgroundColor, color: textColor }}> {text} </div>
                        :
                        <div>No Heading Information</div>
                    }
                </div>
                <div className={'search-result-heading-right'} onClick={onClick}>
                    {rightHandSide}
                </div>
            </div>
        </Fragment>
    )
}